import md5 from 'md5';
import sha256 from 'sha256';

export const encryptPassword = (password) => sha256(md5(password));

export const formatPhoneNumber = (phoneNumberString) => {
    const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return null;
};

export const extractValue = (obj = {}, valueKey = 'value') => obj[valueKey];

export const extractObjectByValue = (array, value, valueKey = 'value') => array.find((item) => item[valueKey] === value);

export const pickProperties = (object, keys) =>
    keys.reduce((obj, key) => {
        if (object && Object.prototype.hasOwnProperty.call(object, key)) {
            // eslint-disable-next-line no-param-reassign
            obj[key] = object[key];
        }
        return obj;
    }, {});
